import { useState } from "react";
import { api } from "../api.js";
import { ErrorBox, Field } from "../ui.jsx";

function AuthFrame({ title, children }) {
  return (
    <div className="auth">
      <div className="auth-card">
        <div className="auth-brand"><span className="brand-mark" aria-hidden="true" />فريق<small>Smart Team</small></div>
        <h1>{title}</h1>
        {children}
      </div>
      <p className="auth-foot">الحلول الذكية لتجهيز المباني الذكية والأعمال الذكية</p>
    </div>
  );
}

export function Login({ onDone }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [remember, setRemember] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      onDone(await api.login(email.trim(), password, remember));
    } catch (err) {
      setError(err);
    } finally {
      setBusy(false);
    }
  };
  return (
    <AuthFrame title="تسجيل الدخول">
      <form onSubmit={submit} className="stack">
        <Field label="البريد الإلكتروني">
          <input type="email" autoComplete="username" dir="ltr" required value={email} onChange={(e) => setEmail(e.target.value)} />
        </Field>
        <Field label="كلمة المرور">
          <input type="password" autoComplete="current-password" required value={password}
                 onChange={(e) => setPassword(e.target.value)} />
        </Field>
        <label className="check"><input type="checkbox" checked={remember} onChange={(e) => setRemember(e.target.checked)} />
          تذكّرني على هذا الجهاز</label>
        <ErrorBox error={error} />
        <button className="btn btn-primary btn-block" disabled={busy}>{busy ? "جارٍ الدخول…" : "دخول"}</button>
        <p className="muted small">الحسابات تُنشأ من مدير النظام. إذا نسيت كلمة المرور اطلب رابطًا جديدًا من الإدارة.</p>
      </form>
    </AuthFrame>
  );
}

export function AcceptInvite({ token, onDone }) {
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);
  const mismatch = confirm && password !== confirm;
  const submit = async (e) => {
    e.preventDefault();
    if (mismatch) return;
    setBusy(true);
    setError(null);
    try {
      onDone(await api.acceptInvite(token, password));
    } catch (err) {
      setError(err);
    } finally {
      setBusy(false);
    }
  };
  if (!token) return <AuthFrame title="رابط غير صالح"><p>افتح الرابط كما أرسلته الإدارة.</p></AuthFrame>;
  return (
    <AuthFrame title="تفعيل الحساب">
      <form onSubmit={submit} className="stack">
        <p className="muted">اختر كلمة مرور لحسابك (8 أحرف على الأقل، تجمع بين الأحرف والأرقام).</p>
        <Field label="كلمة المرور الجديدة">
          <input type="password" autoComplete="new-password" required minLength={8} value={password}
                 onChange={(e) => setPassword(e.target.value)} />
        </Field>
        <Field label="تأكيد كلمة المرور" error={mismatch}>
          <input type="password" autoComplete="new-password" required value={confirm} onChange={(e) => setConfirm(e.target.value)} />
          {mismatch && <span className="field-hint">كلمتا المرور غير متطابقتين</span>}
        </Field>
        <ErrorBox error={error} />
        <button className="btn btn-primary btn-block" disabled={busy || mismatch}>{busy ? "جارٍ التفعيل…" : "تفعيل الحساب"}</button>
      </form>
    </AuthFrame>
  );
}
